// Transaction type values from the backend

export enum CashFlowColumnAlias {
  DATE_OF_TRANSACTION = 'date_of_transaction',
  AMOUNT = 'amount',
  TRANSACTION_TYPE = 'transaction_type',
  OWNER = 'owner',
  ENTITY = 'entity',
  ALL_SECURITY = 'all_security',
}

export enum CashFlowColumnValue {
  DATE_OF_TRANSACTION = 'Date of Transaction',
  AMOUNT = 'Amount',
  TRANSACTION_TYPE = 'Transaction Type',
  OWNER = 'Owner',
  ENTITY = 'Entity',
  ALL_SECURITY = 'Security',
}

export const CashFlowColumnNames: CashFlowColumnAlias[] = [
  CashFlowColumnAlias.DATE_OF_TRANSACTION,
  CashFlowColumnAlias.AMOUNT,
  CashFlowColumnAlias.TRANSACTION_TYPE,
  CashFlowColumnAlias.OWNER,
  CashFlowColumnAlias.ENTITY,
  CashFlowColumnAlias.ALL_SECURITY,
];

export const TRANSACTION_TYPE = {
  INVESTMENT: 'INVESTMENT',
  REALIZED_PROCEEDS: 'REALIZED_PROCEEDS',
  UNREALIZED_VALUE: 'UNREALIZED_VALUE',
} as const;

export type TransactionType = typeof TRANSACTION_TYPE[keyof typeof TRANSACTION_TYPE];

// Transaction types that are outflows (should have negative amounts)
export const OUTFLOW_TRANSACTION_TYPES: TransactionType[] = [
  TRANSACTION_TYPE.INVESTMENT,
];

// Transaction types that are inflows (should have positive amounts)
export const INFLOW_TRANSACTION_TYPES: TransactionType[] = [
  TRANSACTION_TYPE.REALIZED_PROCEEDS,
  TRANSACTION_TYPE.UNREALIZED_VALUE,
];

// CSS class names for row coloring based on is_virtual
export const ROW_CLASS = {
  // Green = virtual/system-calculated rows (read-only)
  VIRTUAL: 'cash-flow-row--green',
  // Blue = manually added rows (editable)
  MANUAL: 'cash-flow-row--blue',
} as const;

/**
 * Get the CSS class name for a row based on whether it's virtual (system-calculated) or manual
 * @param isVirtual - true if the row is system-calculated, false if manually added
 */
export const getRowClassByVirtual = (isVirtual: boolean): string =>
  isVirtual ? ROW_CLASS.VIRTUAL : ROW_CLASS.MANUAL;
